module.exports = __webpack_public_path__ + "static/about_simulator_clouds_art-e6e7687c4c9924b684c6d21526ef684f.png";